import { Helpers } from '../../helpers';
import { IScenario } from '../../interfaces/iscenario';
import { AreaTargetFormation } from '../area-target-formation';
import { AssetTeam } from '../asset-team';
import { AutoMappingCombiningTargetFormation } from '../auto-mapping-combining-target-formation';
import { AutoRelationship } from '../auto-relationship';
import { BudgetAdjustment } from '../budget-adjustment';
import { BudgetCategory } from '../budget-category';
import { ConstraintAreaTeamRig } from '../constraint-area-team-rig';
import { ConstraintCalendarRestriction } from '../constraint-calendar-restriction';
import { ConstraintDrillFracInterference } from '../constraint-drill-frac-interference';
import { ConstraintFacilityChoke } from '../constraint-facility-choke';
import { ConstraintFacilityConstrainedSchedule } from '../constraint-facility-constrained-schedule';
import { ConstraintFacilityExpansion } from '../constraint-facility-expansion';
import { ConstraintFacilityInitialBuild } from '../constraint-facility-initial-build';
import { ConstraintFacilityTruck } from '../constraint-facility-truck';
import { ConstraintLeaseObligation } from '../constraint-lease-obligation';
import { ConstraintManualObligation } from '../constraint-manual-obligation';
import { ConstraintMaxFracFleetPerArea } from '../constraint-max-frac-fleet-per-area';
import { ConstraintMinMaxRigsPerArea } from '../constraint-min-max-rigs-per-area';
import { ConstraintPopSlidesAllowableDay } from '../constraint-pop-slides-allowable-day';
import { ConstraintPrematureWellShutdown } from '../constraint-premature-well-shutdown';
import { ConstraintProvenUndrilledObligation } from '../constraint-proven-undrilled-obligation';
import { ConstraintSpudLimit } from '../constraint-spud-limit';
import { ConstraintWaterExpress } from '../constraint-water-express';
import { ConstraintWaterSupply } from '../constraint-water-supply';
import { DrillGroup } from '../drill-group';
import { EconomicsCalculationsAnnualValue } from '../economics-calculations-annual-value';
import { EconomicsCalculationsDailyValue } from '../economics-calculations-daily-value';
import { EconomicsSetting } from '../economics-setting';
import { EffectivePercentAttainment } from '../effective-percent-attainment';
import { Forecast } from '../forecast';
import { FracFleet } from '../frac-fleet';
import { FracGroupSisterPad } from '../frac-group-sister-pad';
import { LongRunningProcess } from '../long-running-process';
import { Pad } from '../pad';
import { PrioritizationCriterion } from '../prioritization-criterion';
import { Project } from '../project';
import { ResourceLevelingSetting } from '../resource-leveling-setting';
import { Rig } from '../rig';
import { RigAvailability } from '../rig-availability';
import { RigRateDetail } from '../rig-rate-detail';
import { ScenarioAssetMapping } from '../scenario-asset-mapping';
import { ScenarioBuildStatus } from '../scenario-build-status';
import { ScenarioCase } from '../scenario-case';
import { ScenarioChangeRequest } from '../scenario-change-request';
import { ScenarioDetail } from '../scenario-detail';
import { ScenarioDrillFracOverlap } from '../scenario-drill-frac-overlap';
import { ScenarioStatus } from '../scenario-status';
import { ScenarioType } from '../scenario-type';
import { ScenarioWell } from '../scenario-well';
import { Schedule } from '../schedule';
import { ScheduleBuildSetting } from '../schedule-build-setting';
import { SecurityLevel } from '../security-level';
import { Setting } from '../setting';

export class ScenarioBase {
  ScenarioId: number;
  ScenarioNumber: number;
  Name: string;
  ScenarioTypeId: number;
  Description: string;
  StartDate: Date | null;
  EndDate: Date | null;
  PublishId: number;
  SortOrder: number | null;
  StimEfficiency: number | null;
  AssetTeamId: number;
  RigRampWellSet: boolean;
  HasPreSpudProgressConstraint: boolean;
  HasJointVentureRigs: boolean;
  IsLeaseObligationConstraintApplied: boolean;
  IsManualObligationConstraintApplied: boolean;
  IsProvenUndrilledObligationConstraintApplied: boolean;
  IsDrillFracInterferenceConstraintApplied: boolean;
  IsPrematureWellShutinConstraintApplied: boolean;
  IsCalenderRestrictionConstraintApplied: boolean;
  IsSpudLimitConstraintApplied: boolean;
  IsAreaTeamRigConstraintApplied: boolean;
  IsMaxFracFleetPerAreaConstraintApplied: boolean;
  IsMaxWaterSupplyConstraintApplied: boolean;
  IsMaxWaterExpressConstraintApplied: boolean;
  IsFacilityInitialBuildConstraintApplied: boolean;
  IsFacilityExpansionConstraintApplied: boolean;
  IsConstrainedScheduleConstraintApplied: boolean;
  IsAllowableDayPopSlideConstraintApplied: boolean;
  IsTruckingConstraintApplied: boolean;
  ScenarioStatusId: number;
  Reason: string | null;
  ChangeJustification: string | null;
  CreateTStamp: Date;
  CreatedByUID: string | null;
  IsMaxMinRigsConstraintApplied: boolean;
  IsChokeConstraintApplied: boolean;
  BaseScenarioId: number | null;
  BuildEndDate: Date | null;
  BuildStartDate: Date | null;
  GeneratedScenarioIdentifier: string | null;
  IsNoProductionForecast: boolean;
  ProductionForecastEndDate: Date | null;
  ProductionForecastStartDate: Date | null;
  ProposedChange: string | null;
  IsLiveScenario: boolean | null;
  IsWellGroupingUnitBoundaryRecognized: boolean;
  WellGroupingAllowedProximityMeters: number;
  SecurityLevelId: number | null;
  RefreshWellsAutoMapping: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  ApprovalGeneralComments: string | null;

  AreaTargetFormations_Scenario?: Array<AreaTargetFormation> | null;
  AutoMappingCombiningTargetFormations_Scenario?: Array<AutoMappingCombiningTargetFormation> | null;
  AutoRelationships_Scenario?: Array<AutoRelationship> | null;
  BudgetAdjustments_Scenario?: Array<BudgetAdjustment> | null;
  BudgetCategories_Scenario?: Array<BudgetCategory> | null;
  ConstraintAreaTeamRigs_Scenario?: Array<ConstraintAreaTeamRig> | null;
  ConstraintCalendarRestrictions_Scenario?: Array<ConstraintCalendarRestriction> | null;
  ConstraintDrillFracInterferences_Scenario?: Array<ConstraintDrillFracInterference> | null;
  ConstraintFacilityChokes_Scenario?: Array<ConstraintFacilityChoke> | null;
  ConstraintFacilityConstrainedSchedules_Scenario?: Array<ConstraintFacilityConstrainedSchedule> | null;
  ConstraintFacilityExpansions_Scenario?: Array<ConstraintFacilityExpansion> | null;
  ConstraintFacilityInitialBuilds_Scenario?: Array<ConstraintFacilityInitialBuild> | null;
  ConstraintFacilityTrucks_Scenario?: Array<ConstraintFacilityTruck> | null;
  ConstraintLeaseObligations_Scenario?: Array<ConstraintLeaseObligation> | null;
  ConstraintManualObligations_Scenario?: Array<ConstraintManualObligation> | null;
  ConstraintMaxFracFleetPerAreas_Scenario?: Array<ConstraintMaxFracFleetPerArea> | null;
  ConstraintMinMaxRigsPerAreas_Scenario?: Array<ConstraintMinMaxRigsPerArea> | null;
  ConstraintPopSlidesAllowableDays_Scenario?: Array<ConstraintPopSlidesAllowableDay> | null;
  ConstraintPrematureWellShutdowns_Scenario?: Array<ConstraintPrematureWellShutdown> | null;
  ConstraintProvenUndrilledObligations_Scenario?: Array<ConstraintProvenUndrilledObligation> | null;
  ConstraintSpudLimits_Scenario?: Array<ConstraintSpudLimit> | null;
  ConstraintWaterExpresses_Scenario?: Array<ConstraintWaterExpress> | null;
  ConstraintWaterSupplies_Scenario?: Array<ConstraintWaterSupply> | null;
  DrillGroups_Scenario?: Array<DrillGroup> | null;
  EconomicsCalculationsAnnualValues_Scenario?: Array<EconomicsCalculationsAnnualValue> | null;
  EconomicsSettings_Scenario?: Array<EconomicsSetting> | null;
  EffectivePercentAttainments_Scenario?: Array<EffectivePercentAttainment> | null;
  Forecasts_Scenario?: Array<Forecast> | null;
  FracFleets_Scenario?: Array<FracFleet> | null;
  FracGroupSisterPads_Scenario?: Array<FracGroupSisterPad> | null;
  LongRunningProcesses_Scenario?: Array<LongRunningProcess> | null;
  Pads_Scenario?: Array<Pad> | null;
  PrioritizationCriteria_Scenario?: Array<PrioritizationCriterion> | null;
  Projects_Scenario?: Array<Project> | null;
  ResourceLevelingSettings_Scenario?: Array<ResourceLevelingSetting> | null;
  RigAvailabilities_Scenario?: Array<RigAvailability> | null;
  RigRateDetails_Scenario?: Array<RigRateDetail> | null;
  Rigs_Scenario?: Array<Rig> | null;
  ScenarioAssetMappings_Scenario?: Array<ScenarioAssetMapping> | null;
  ScenarioBuildStatuses_Scenario?: Array<ScenarioBuildStatus> | null;
  ScenarioCases_Scenario?: Array<ScenarioCase> | null;
  ScenarioChangeRequests_Scenario?: Array<ScenarioChangeRequest> | null;
  ScenarioDetails_Scenario?: Array<ScenarioDetail> | null;
  ScenarioDrillFracOverlaps_Scenario?: Array<ScenarioDrillFracOverlap> | null;
  ScenarioWells_Scenario?: Array<ScenarioWell> | null;
  ScheduleBuildSettings_Scenario?: Array<ScheduleBuildSetting> | null;
  Schedules_Scenario?: Array<Schedule> | null;
  Settings_Scenario?: Array<Setting> | null;
  EconomicsCalculationsDailyValues_Scenarioid?: Array<EconomicsCalculationsDailyValue> | null;
  AssetTeam?: AssetTeam;
  ScenarioStatus?: ScenarioStatus;
  ScenarioType?: ScenarioType;
  SecurityLevel?: SecurityLevel;

  constructor(item?: IScenario) {
    if (item) {

      this.ScenarioId = item.ScenarioId;
      this.ScenarioNumber = item.ScenarioNumber;
      this.Name = item.Name;
      this.ScenarioTypeId = item.ScenarioTypeId;
      this.Description = item.Description;
      this.StartDate = item.StartDate ? new Date(item.StartDate) : null;
      this.EndDate = item.EndDate ? new Date(item.EndDate) : null;
      this.PublishId = item.PublishId;
      this.SortOrder = item.SortOrder;
      this.StimEfficiency = item.StimEfficiency;
      this.AssetTeamId = item.AssetTeamId;
      this.RigRampWellSet = item.RigRampWellSet;
      this.HasPreSpudProgressConstraint = item.HasPreSpudProgressConstraint;
      this.HasJointVentureRigs = item.HasJointVentureRigs;
      this.IsLeaseObligationConstraintApplied = item.IsLeaseObligationConstraintApplied;
      this.IsManualObligationConstraintApplied = item.IsManualObligationConstraintApplied;
      this.IsProvenUndrilledObligationConstraintApplied = item.IsProvenUndrilledObligationConstraintApplied;
      this.IsDrillFracInterferenceConstraintApplied = item.IsDrillFracInterferenceConstraintApplied;
      this.IsPrematureWellShutinConstraintApplied = item.IsPrematureWellShutinConstraintApplied;
      this.IsCalenderRestrictionConstraintApplied = item.IsCalenderRestrictionConstraintApplied;
      this.IsSpudLimitConstraintApplied = item.IsSpudLimitConstraintApplied;
      this.IsAreaTeamRigConstraintApplied = item.IsAreaTeamRigConstraintApplied;
      this.IsMaxFracFleetPerAreaConstraintApplied = item.IsMaxFracFleetPerAreaConstraintApplied;
      this.IsMaxWaterSupplyConstraintApplied = item.IsMaxWaterSupplyConstraintApplied;
      this.IsMaxWaterExpressConstraintApplied = item.IsMaxWaterExpressConstraintApplied;
      this.IsFacilityInitialBuildConstraintApplied = item.IsFacilityInitialBuildConstraintApplied;
      this.IsFacilityExpansionConstraintApplied = item.IsFacilityExpansionConstraintApplied;
      this.IsConstrainedScheduleConstraintApplied = item.IsConstrainedScheduleConstraintApplied;
      this.IsAllowableDayPopSlideConstraintApplied = item.IsAllowableDayPopSlideConstraintApplied;
      this.IsTruckingConstraintApplied = item.IsTruckingConstraintApplied;
      this.ScenarioStatusId = item.ScenarioStatusId;
      this.Reason = item.Reason;
      this.ChangeJustification = item.ChangeJustification;
      this.CreateTStamp = item.CreateTStamp ? new Date(item.CreateTStamp) : null;
      this.CreatedByUID = item.CreatedByUID;
      this.IsMaxMinRigsConstraintApplied = item.IsMaxMinRigsConstraintApplied;
      this.IsChokeConstraintApplied = item.IsChokeConstraintApplied;
      this.BaseScenarioId = item.BaseScenarioId;
      this.BuildEndDate = item.BuildEndDate ? new Date(item.BuildEndDate) : null;
      this.BuildStartDate = item.BuildStartDate ? new Date(item.BuildStartDate) : null;
      this.GeneratedScenarioIdentifier = item.GeneratedScenarioIdentifier;
      this.IsNoProductionForecast = item.IsNoProductionForecast;
      this.ProductionForecastEndDate = item.ProductionForecastEndDate ? new Date(item.ProductionForecastEndDate) : null;
      this.ProductionForecastStartDate = item.ProductionForecastStartDate ? new Date(item.ProductionForecastStartDate) : null;
      this.ProposedChange = item.ProposedChange;
      this.IsLiveScenario = item.IsLiveScenario;
      this.IsWellGroupingUnitBoundaryRecognized = item.IsWellGroupingUnitBoundaryRecognized;
      this.WellGroupingAllowedProximityMeters = item.WellGroupingAllowedProximityMeters;
      this.SecurityLevelId = item.SecurityLevelId;
      this.RefreshWellsAutoMapping = item.RefreshWellsAutoMapping;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.ApprovalGeneralComments = item.ApprovalGeneralComments;

      this.AreaTargetFormations_Scenario = Helpers.createClassArray(AreaTargetFormation, item.AreaTargetFormations_Scenario);
      this.AutoMappingCombiningTargetFormations_Scenario = Helpers.createClassArray(AutoMappingCombiningTargetFormation, item.AutoMappingCombiningTargetFormations_Scenario);
      this.AutoRelationships_Scenario = Helpers.createClassArray(AutoRelationship, item.AutoRelationships_Scenario);
      this.BudgetAdjustments_Scenario = Helpers.createClassArray(BudgetAdjustment, item.BudgetAdjustments_Scenario);
      this.BudgetCategories_Scenario = Helpers.createClassArray(BudgetCategory, item.BudgetCategories_Scenario);
      this.ConstraintAreaTeamRigs_Scenario = Helpers.createClassArray(ConstraintAreaTeamRig, item.ConstraintAreaTeamRigs_Scenario);
      this.ConstraintCalendarRestrictions_Scenario = Helpers.createClassArray(ConstraintCalendarRestriction, item.ConstraintCalendarRestrictions_Scenario);
      this.ConstraintDrillFracInterferences_Scenario = Helpers.createClassArray(ConstraintDrillFracInterference, item.ConstraintDrillFracInterferences_Scenario);
      this.ConstraintFacilityChokes_Scenario = Helpers.createClassArray(ConstraintFacilityChoke, item.ConstraintFacilityChokes_Scenario);
      this.ConstraintFacilityConstrainedSchedules_Scenario = Helpers.createClassArray(ConstraintFacilityConstrainedSchedule, item.ConstraintFacilityConstrainedSchedules_Scenario);
      this.ConstraintFacilityExpansions_Scenario = Helpers.createClassArray(ConstraintFacilityExpansion, item.ConstraintFacilityExpansions_Scenario);
      this.ConstraintFacilityInitialBuilds_Scenario = Helpers.createClassArray(ConstraintFacilityInitialBuild, item.ConstraintFacilityInitialBuilds_Scenario);
      this.ConstraintFacilityTrucks_Scenario = Helpers.createClassArray(ConstraintFacilityTruck, item.ConstraintFacilityTrucks_Scenario);
      this.ConstraintLeaseObligations_Scenario = Helpers.createClassArray(ConstraintLeaseObligation, item.ConstraintLeaseObligations_Scenario);
      this.ConstraintManualObligations_Scenario = Helpers.createClassArray(ConstraintManualObligation, item.ConstraintManualObligations_Scenario);
      this.ConstraintMaxFracFleetPerAreas_Scenario = Helpers.createClassArray(ConstraintMaxFracFleetPerArea, item.ConstraintMaxFracFleetPerAreas_Scenario);
      this.ConstraintMinMaxRigsPerAreas_Scenario = Helpers.createClassArray(ConstraintMinMaxRigsPerArea, item.ConstraintMinMaxRigsPerAreas_Scenario);
      this.ConstraintPopSlidesAllowableDays_Scenario = Helpers.createClassArray(ConstraintPopSlidesAllowableDay, item.ConstraintPopSlidesAllowableDays_Scenario);
      this.ConstraintPrematureWellShutdowns_Scenario = Helpers.createClassArray(ConstraintPrematureWellShutdown, item.ConstraintPrematureWellShutdowns_Scenario);
      this.ConstraintProvenUndrilledObligations_Scenario = Helpers.createClassArray(ConstraintProvenUndrilledObligation, item.ConstraintProvenUndrilledObligations_Scenario);
      this.ConstraintSpudLimits_Scenario = Helpers.createClassArray(ConstraintSpudLimit, item.ConstraintSpudLimits_Scenario);
      this.ConstraintWaterExpresses_Scenario = Helpers.createClassArray(ConstraintWaterExpress, item.ConstraintWaterExpresses_Scenario);
      this.ConstraintWaterSupplies_Scenario = Helpers.createClassArray(ConstraintWaterSupply, item.ConstraintWaterSupplies_Scenario);
      this.DrillGroups_Scenario = Helpers.createClassArray(DrillGroup, item.DrillGroups_Scenario);
      this.EconomicsCalculationsAnnualValues_Scenario = Helpers.createClassArray(EconomicsCalculationsAnnualValue, item.EconomicsCalculationsAnnualValues_Scenario);
      this.EconomicsSettings_Scenario = Helpers.createClassArray(EconomicsSetting, item.EconomicsSettings_Scenario);
      this.EffectivePercentAttainments_Scenario = Helpers.createClassArray(EffectivePercentAttainment, item.EffectivePercentAttainments_Scenario);
      this.Forecasts_Scenario = Helpers.createClassArray(Forecast, item.Forecasts_Scenario);
      this.FracFleets_Scenario = Helpers.createClassArray(FracFleet, item.FracFleets_Scenario);
      this.FracGroupSisterPads_Scenario = Helpers.createClassArray(FracGroupSisterPad, item.FracGroupSisterPads_Scenario);
      this.LongRunningProcesses_Scenario = Helpers.createClassArray(LongRunningProcess, item.LongRunningProcesses_Scenario);
      this.Pads_Scenario = Helpers.createClassArray(Pad, item.Pads_Scenario);
      this.PrioritizationCriteria_Scenario = Helpers.createClassArray(PrioritizationCriterion, item.PrioritizationCriteria_Scenario);
      this.Projects_Scenario = Helpers.createClassArray(Project, item.Projects_Scenario);
      this.ResourceLevelingSettings_Scenario = Helpers.createClassArray(ResourceLevelingSetting, item.ResourceLevelingSettings_Scenario);
      this.RigAvailabilities_Scenario = Helpers.createClassArray(RigAvailability, item.RigAvailabilities_Scenario);
      this.RigRateDetails_Scenario = Helpers.createClassArray(RigRateDetail, item.RigRateDetails_Scenario);
      this.Rigs_Scenario = Helpers.createClassArray(Rig, item.Rigs_Scenario);
      this.ScenarioAssetMappings_Scenario = Helpers.createClassArray(ScenarioAssetMapping, item.ScenarioAssetMappings_Scenario);
      this.ScenarioBuildStatuses_Scenario = Helpers.createClassArray(ScenarioBuildStatus, item.ScenarioBuildStatuses_Scenario);
      this.ScenarioCases_Scenario = Helpers.createClassArray(ScenarioCase, item.ScenarioCases_Scenario);
      this.ScenarioChangeRequests_Scenario = Helpers.createClassArray(ScenarioChangeRequest, item.ScenarioChangeRequests_Scenario);
      this.ScenarioDetails_Scenario = Helpers.createClassArray(ScenarioDetail, item.ScenarioDetails_Scenario);
      this.ScenarioDrillFracOverlaps_Scenario = Helpers.createClassArray(ScenarioDrillFracOverlap, item.ScenarioDrillFracOverlaps_Scenario);
      this.ScenarioWells_Scenario = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_Scenario);
      this.ScheduleBuildSettings_Scenario = Helpers.createClassArray(ScheduleBuildSetting, item.ScheduleBuildSettings_Scenario);
      this.Schedules_Scenario = Helpers.createClassArray(Schedule, item.Schedules_Scenario);
      this.Settings_Scenario = Helpers.createClassArray(Setting, item.Settings_Scenario);
      this.EconomicsCalculationsDailyValues_Scenarioid = Helpers.createClassArray(EconomicsCalculationsDailyValue, item.EconomicsCalculationsDailyValues_Scenarioid);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.ScenarioStatus = new ScenarioStatus(item.ScenarioStatus);
      this.ScenarioType = new ScenarioType(item.ScenarioType);
      this.SecurityLevel = new SecurityLevel(item.SecurityLevel);
    }
  }
}